// Vuex
import { defaultObj } from './state'

// Utilities
import isEmpty from '../../utility/isEmpty'

export default {
  setStore (state, data) {
    if (data.number !== undefined) {
      state.number = data.number
      state.defaultStoreSet = false // Prevent changing to new default via product config calls
    }

    if (data.address !== undefined) {
      state.address = data.address
    }

    if (data.addressStreet !== undefined) {
      state.addressStreet = data.addressStreet
    }

    if (data.city !== undefined) {
      state.city = data.city
    }

    if (data.hoursRaw !== undefined) {
      state.hoursRaw = data.hoursRaw
    }

    if (data.lat !== undefined) {
      state.lat = data.lat
    }

    if (data.long !== undefined) {
      state.long = data.long
    }

    if (data.name !== undefined) {
      state.name = data.name
    }

    if (data.phone !== undefined) {
      state.phone = data.phone
    }

    if (data.state !== undefined) {
      state.state = data.state
    }

    if (data.timezone !== undefined) {
      state.timezone = data.timezone
    }

    if (data.zip !== undefined) {
      state.zip = data.zip
    }

    if (data.brandId !== undefined) {
      state.brandId = data.brandId
    }

    if (data.mobileMoneyLocation !== undefined) {
      state.mobileMoneyLocation = data.mobileMoneyLocation
    }

    if (data.mobileMoneyType !== undefined) {
      state.mobileMoneyType = data.mobileMoneyType
    }
  },

  setStoreForMobile (state, data) {
    if (data.storeInfo.id !== undefined) {
      state.number = data.storeInfo.id
      state.defaultStoreSet = false // Prevent changing to new default via product config calls
    }

    if (data.storeInfo.address !== undefined) {
      state.address = data.storeInfo.address
    }

    if (data.storeInfo.addressStreet !== undefined) {
      state.addressStreet = data.storeInfo.addressStreet
    }

    if (data.storeInfo.city !== undefined) {
      state.city = data.storeInfo.city
    }

    if (data.storeInfo.hourRaw !== undefined) {
      state.hours = data.storeInfo.hoursRaw
    }

    if (data.storeInfo.latitude !== undefined) {
      state.lat = data.storeInfo.latitude
    }

    if (data.storeInfo.longitude !== undefined) {
      state.long = data.storeInfo.longitude
    }

    if (data.storeInfo.name !== undefined) {
      state.name = data.storeInfo.name
    }

    if (data.storeInfo.phone !== undefined) {
      state.phone = data.storeInfo.phone
    }

    if (data.storeInfo.state?.label !== undefined) {
      state.state = data.storeInfo.state.label
    }

    if (data.storeInfo.timezone !== undefined) {
      state.timezone = data.storeInfo.timezone
    }

    if (data.storeInfo.zip !== undefined) {
      state.zip = data.storeInfo.zip
    }

    if (data.storeInfo.brandId !== undefined) {
      state.brandId = data.storeInfo.brandId
    }

    if (data.mobileMoneyLocation !== undefined) {
      state.mobileMoneyLocation = data.mobileMoneyLocation
    }

    if (data.mobileMoneyType !== undefined) {
      state.mobileMoneyType = data.mobileMoneyType
    }
  },

  updateDefaultStoreNumber (state, data) {
    if (!state.defaultStoreSet) {
      return
    }

    state.number = data.storeNumber
  },

  setQrScannedStoreNumber (state, data) {
    const qrCodeScanned = !isEmpty(data.qrScannedStoreNumber)
    state.qrCodeScannedStore = qrCodeScanned

    if (qrCodeScanned) {
      state.number = Number.parseInt(data.qrScannedStoreNumber.toString())
      state.defaultStoreSet = false
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
